import VueRouter from "vue-router";
import routes from "./routes";
import swal from "sweetalert2";

// function checkInactivity() {
//   let timer;
//   window.clearTimeout(timer);
//   timer = window.setTimeout(() => {
//     console.log("logout");
//     alert("Inactivity  for 5 minutes");
//     util.logoutOnRefresh();
//   }, 5000);
// }

// configure router
const router = new VueRouter({
  routes, // short for routes: routes
  linkActiveClass: "active",
  scrollBehavior() {
    return new Promise((resolve) => {
      resolve({ top: 0, left: 0 });
    });
  },
});

router.beforeEach((to, from, next) => {
  // redirect to login page if not logged in and trying to access a restricted page
  const publicPages = [
    "/login",
    "/forgotpassword",
    "/recoverpassword",
    "/land-register",
    "/vessel-register",
    "/vessel-register-1",
    "/vendor-register-2",
    "/vendor-register-1",
    "/vendor-register",
    "/authorities-register",
  ];

  const authRequired = !publicPages.includes(to.path);
  const token = $cookies.get("token");
  if (authRequired) {
    if (!(typeof token === "string")) {
      next("/login");
      return;
    }

    const jwtPayload = token.split(".")[1];
    let current = Math.floor(Date.now() / 1000);
    let exp = JSON.parse(atob(jwtPayload)).exp;
    if (exp - current <= 0) {
      $cookies.remove("token");
      swal({
        title: `Error!`,
        text: "Session expired! Please re-login.",
        buttonsStyling: false,
        confirmButtonClass: "btn btn-primary btn-fill",
        type: "error",
        allowOutsideClick: false,
      }).then((result) => {
        console.log(result.value);
        if (result.value) {
          return next("/login");
        }
      });
    }
  }
  next();
});

export default router;
